import React from 'react'
import { connect } from 'react-redux'
import SiteContainer from '../../components/layout/SiteContainer'
import { InnerContentContainer } from '../../styles/styled-elements'

class FlatContent extends React.Component {

  constructor(props) {
    super(props)
    const { path } = props.match
    this.state = {
      contentId: path.replace(/^\//,'')
    }
  }

  componentDidMount() {
  }

  getContent() {
    if (this.state.contentId==='help') {
      return <div>
        <h1>Help</h1>
        <p>This is the new version of TainData Panorama.</p>
        <p>There have been a huge number of changes and improvements, but some features have not yet been completed and we'll understand if you find some things confusing.</p>
        <p>If you need help, please contact us at:</p>
        <p>+61 435 205 399</p>
        <p>tom@tain.com.au</p>
      </div>
    }
  }

  renderBody = (props,state) => <SiteContainer isSignedIn={props.apiAuth.isSignedIn}>
    <InnerContentContainer>
      {this.getContent()}
    </InnerContentContainer>
  </SiteContainer>

  render = () => this.renderBody(this.props,this.state)

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
  }),
)(FlatContent)



// WEBPACK FOOTER //
// ./src/containers/flatContent/index.js